var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcodeUnmatched(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/icon / newbarcode - unknown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-/-newbarcode---unknown",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-newbarcode",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.444444444,
    y: 0.533333333,
    width: 1.33333333,
    height: 13.3333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 2.44444444,
    y: 0.533333333,
    width: 1,
    height: 13.3333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 4.44444444,
    y: 0.533333333,
    width: 1,
    height: 13.3333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 5.77777778,
    y: 0.533333333,
    width: 1.33333333,
    height: 13.3333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 7.77777778,
    y: 0.533333333,
    width: 1,
    height: 13.3333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 9.11111111,
    y: 0.533333333,
    width: 1.33333333,
    height: 13.3333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 12.4444444,
    y: 0.533333333,
    width: 1.33333333,
    height: 13.3333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 14.4444444,
    y: 0.533333333,
    width: 1,
    height: 13.3333333
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.000000, 6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EBEBEB",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.328,6.518 C4.334,6.145 4.376,5.85 4.455,5.633 C4.533,5.417 4.693,5.177 4.935,4.913 L5.551,4.277 C5.815,3.979 5.947,3.659 5.947,3.317 C5.947,2.987 5.861,2.729 5.688,2.543 C5.515,2.356 5.264,2.263 4.935,2.263 C4.615,2.263 4.357,2.347 4.163,2.517 C3.968,2.687 3.871,2.914 3.871,3.199 L3,3.199 C3.006,2.691 3.188,2.281 3.544,1.969 C3.9,1.656 4.364,1.5 4.934,1.5 C5.528,1.5 5.99,1.66 6.321,1.978 C6.652,2.296 6.818,2.733 6.818,3.288 C6.818,3.838 6.564,4.379 6.055,4.913 L5.542,5.421 C5.312,5.676 5.198,6.041 5.198,6.518 L4.328,6.518 L4.328,6.518 Z M4.29,8.01 C4.29,7.87 4.333,7.75 4.42,7.655 C4.506,7.559 4.633,7.511 4.803,7.511 C4.973,7.511 5.101,7.559 5.189,7.655 C5.277,7.751 5.321,7.869 5.321,8.01 C5.321,8.152 5.277,8.269 5.189,8.361 C5.101,8.454 4.972,8.5 4.803,8.5 C4.633,8.5 4.506,8.454 4.419,8.361 C4.333,8.269 4.289,8.151 4.289,8.011 L4.29,8.01 Z",
    id: "Shape",
    fillOpacity: 0.87,
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeUnmatched);
export default __webpack_public_path__ + "static/media/barcode_unmatched.2d86e9d644f00f1114a8844b3645e734.svg";
export { ForwardRef as ReactComponent };